import { render, staticRenderFns } from "./CommissionDetail.vue?vue&type=template&id=6bf810ab&"
import script from "./CommissionDetail.vue?vue&type=script&lang=js&"
export * from "./CommissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommissionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports